import { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

const SETTINGS_DOC = doc(db, 'siteContent', 'settings');

function Toggle({ label, description, checked, onChange, saving }) {
  return (
    <div className="admin-card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1.5rem' }}>
      <div>
        <div style={{ fontWeight: 700, color: 'var(--navy)', fontSize: '0.95rem', marginBottom: '0.2rem' }}>{label}</div>
        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)' }}>{description}</div>
      </div>
      <button
        onClick={() => onChange(!checked)}
        disabled={saving}
        style={{
          flexShrink: 0,
          width: 52,
          height: 28,
          borderRadius: 14,
          border: 'none',
          cursor: saving ? 'not-allowed' : 'pointer',
          background: checked ? 'var(--navy)' : '#d1d5db',
          position: 'relative',
          transition: 'background 0.25s',
          opacity: saving ? 0.7 : 1,
        }}
        aria-label={label}
      >
        <span style={{
          position: 'absolute',
          top: 3,
          left: checked ? 26 : 3,
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: '#fff',
          transition: 'left 0.25s',
          boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
        }} />
      </button>
    </div>
  );
}

export default function AdminSettings() {
  const [settings, setSettings] = useState({ showClients: true });
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDoc(SETTINGS_DOC).then(snap => {
      if (snap.exists()) setSettings(snap.data());
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const toggle = async (key, value) => {
    const next = { ...settings, [key]: value };
    setSettings(next);
    setSaving(true);
    try {
      await setDoc(SETTINGS_DOC, next);
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      console.error('[AdminSettings] save error:', err);
    }
    setSaving(false);
  };

  if (loading) return (
    <div style={{ padding: '2rem', color: 'var(--text-muted)' }}>Loading settings...</div>
  );

  return (
    <div>
      <h1>
        <span>⚙️</span> Site Settings
        {saved && <span style={{ fontSize: '0.85rem', color: '#16a34a', fontWeight: 500, marginLeft: 12 }}>✓ Saved</span>}
      </h1>

      <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1.5rem', marginTop: '-0.75rem' }}>
        Control which sections are visible on the main website.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', maxWidth: 600 }}>
        <Toggle
          label='Trusted By (Clients) Section'
          description='Shows the "Trusted By" client names section on the homepage.'
          checked={settings.showClients !== false}
          onChange={val => toggle('showClients', val)}
          saving={saving}
        />
      </div>
    </div>
  );
}
